var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('notice-bar',[_vm._v("长按图片可以保存到手机")]),(_vm.spreadImage)?_c('van-image',{attrs:{"src":_vm.spreadImage}}):_c('empty',{attrs:{"description":"图片加载中"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }